export default "__VITE_ASSET__Bp87tsVm__"